'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Icon } from '@/components/icon';
import { PAYMENT_PRESET_FLAG } from '@/features/billing/config';
type PaymentFormAmountProps = {
  setPaymentAmount: (value: number) => void;
  paymentRecurring: boolean;
  showFreeOption?: boolean;
  isFree: boolean;
  setIsFree: (value: boolean) => void;
  defaultAmount?: number;
  costPerPerson?: number;
};
function getPositionFromAmount(amount: number, showFreeOption: boolean = false): number {
  if (amount === 0 && showFreeOption) return 0;
  if (amount <= 5) return 0;
  if (amount <= 25) return amount - 5;
  if (amount <= 45) return 20 + Math.ceil((amount - 25) / 2);
  if (amount <= 95) return 30 + Math.ceil((amount - 45) / 5);
  if (amount <= 500) return 40 + Math.ceil((amount - 100) / 10);
  if (amount <= 1000) return 80 + Math.ceil((amount - 500) / 100);
  if (amount <= 5000) return 85 + Math.ceil((amount - 1000) / 500);
  return 93 + Math.ceil((amount - 5000) / 1000);
}
export function PaymentFormAmount(t0) {
  const $ = _c(79);
  const {
    setPaymentAmount,
    paymentRecurring,
    showFreeOption: t1,
    isFree,
    setIsFree,
    defaultAmount: t2,
    costPerPerson: t3
  } = t0;
  const showFreeOption = t1 === undefined ? false : t1;
  const defaultAmount = t2 === undefined ? 25 : t2;
  const costPerPerson = t3 === undefined ? 5 : t3;
  const initialAmount = showFreeOption ? 0 : defaultAmount;
  let t4;
  if ($[0] !== initialAmount || $[1] !== showFreeOption) {
    t4 = getPositionFromAmount(initialAmount, showFreeOption);
    $[0] = initialAmount;
    $[1] = showFreeOption;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [rangeValue, setRangeValue] = useState(t4);
  const [valueAmount, setValueAmount] = useState(initialAmount);
  let t5;
  if ($[3] !== setIsFree || $[4] !== setPaymentAmount || $[5] !== showFreeOption) {
    t5 = amount => {
      const nextRangeValue = getPositionFromAmount(amount, showFreeOption);
      setRangeValue(nextRangeValue);
      setValueAmount(amount);
      setPaymentAmount(amount);
      if (showFreeOption) {
        setIsFree(amount === 0);
      }
    };
    $[3] = setIsFree;
    $[4] = setPaymentAmount;
    $[5] = showFreeOption;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const setExactAmount = t5;
  let t6;
  if ($[7] !== setIsFree || $[8] !== setPaymentAmount || $[9] !== showFreeOption) {
    t6 = (value, isMinusPlusButton) => {
      let dollarValue;
      if (value === 0) {
        dollarValue = showFreeOption ? 0 : 5;
      } else {
        if (value > 0 && value <= 20) {
          dollarValue = 5 + value;
        } else {
          if (value > 20 && value <= 30) {
            dollarValue = 25 + (value - 20) * 2;
          } else {
            if (value > 30 && value <= 40) {
              dollarValue = 45 + (value - 30) * 5;
            } else {
              if (value > 40 && value <= 80) {
                dollarValue = 100 + (value - 40) * 10;
              } else {
                if (value > 80 && value <= 85) {
                  dollarValue = 500 + (value - 80) * 100;
                } else {
                  if (value > 85 && value <= 93) {
                    dollarValue = 1000 + (value - 85) * 500;
                  } else {
                    dollarValue = 5000 + (value - 93) * 1000;
                  }
                }
              }
            }
          }
        }
      }
      setRangeValue(value);
      setValueAmount(dollarValue);
      if (isMinusPlusButton) {
        setPaymentAmount(dollarValue);
      }
      if (showFreeOption) {
        setIsFree(value === 0);
      }
    };
    $[7] = setIsFree;
    $[8] = setPaymentAmount;
    $[9] = showFreeOption;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const changeAmount = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="tracking-[0.04rem]">I want to bring this film to</p>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== changeAmount || $[13] !== rangeValue) {
    t8 = () => {
      if (rangeValue > 0) {
        changeAmount(rangeValue - 1, true);
      }
    };
    $[12] = changeAmount;
    $[13] = rangeValue;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon name="circle-minus" className="size-7 max-w-7" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8) {
    t10 = <button className="absolute top-[-3px] -left-10 max-[1280px]:relative max-[1280px]:left-0" type="button" onClick={t8}>{t9}</button>;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== changeAmount) {
    t11 = event => changeAmount(Number(event.target.value));
    $[18] = changeAmount;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  let t13;
  if ($[20] !== setPaymentAmount || $[21] !== valueAmount) {
    t12 = () => setPaymentAmount(valueAmount);
    t13 = () => setPaymentAmount(valueAmount);
    $[20] = setPaymentAmount;
    $[21] = valueAmount;
    $[22] = t12;
    $[23] = t13;
  } else {
    t12 = $[22];
    t13 = $[23];
  }
  const t14 = `${rangeValue / 100 * 100}% 100%`;
  let t15;
  if ($[24] !== t14) {
    t15 = {
      backgroundSize: t14
    };
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== rangeValue || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t15) {
    t16 = <fieldset><input type="range" step={1} min={0} max={100} value={rangeValue} onChange={t11} onMouseUp={t12} onTouchEnd={t13} className="h-[10px] w-full appearance-none rounded-[10px] bg-christ-gray-900 bg-linear-to-r from-christ-white-700 to-white bg-no-repeat" style={t15} /></fieldset>;
    $[26] = rangeValue;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== changeAmount || $[33] !== rangeValue) {
    t17 = () => {
      if (rangeValue < 100) {
        changeAmount(rangeValue + 1, true);
      }
    };
    $[32] = changeAmount;
    $[33] = rangeValue;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Icon name="circle-plus" className="size-7 max-w-7" />;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t17) {
    t19 = <button className="absolute top-[-3px] -right-10 max-[1280px]:relative max-[1280px]:right-0" type="button" onClick={t17}>{t18}</button>;
    $[36] = t17;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t10 || $[39] !== t16 || $[40] !== t19) {
    t20 = <div className="relative mx-auto my-6 max-w-[90%] max-[1280px]:grid max-[1280px]:max-w-full max-[1280px]:grid-cols-[auto_1fr_auto] max-[1280px]:gap-8 max-[440px]:gap-4">{t10}{t16}{t19}</div>;
    $[38] = t10;
    $[39] = t16;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== setExactAmount || $[43] !== valueAmount) {
    t21 = PAYMENT_PRESET_FLAG && <div className="mx-auto -mt-2 mb-6 flex max-w-[90%] flex-wrap justify-center gap-3 max-[1280px]:max-w-full">{[{
        amount: 5
      }, {
        amount: 25
      }, {
        amount: 35,
        popular: true
      }, {
        amount: 50
      }, {
        amount: 100
      }, {
        amount: 250
      }, {
        amount: 500
      }].map(t22 => {
        const {
          amount: amount_0,
          popular
        } = t22;
        const isActive = valueAmount === amount_0;
        return <div key={amount_0} className="relative pt-2">{popular && <span className="pointer-events-none absolute -top-1 left-1/2 z-10 -translate-x-1/2 rounded-sm bg-christ-red px-2 py-0.5 font-bold text-[0.65rem] text-white tracking-[0.04rem]">Popular</span>}<button type="button" onClick={() => setExactAmount(amount_0)} className={["min-w-[84px] rounded-sm border px-6 py-4 font-extrabold text-base uppercase tracking-[0.04rem] transition-opacity hover:opacity-80", isActive ? "border-christ-white-900 bg-christ-white-900 text-christ-black-900" : "border-christ-white-900/30 bg-white/5 text-white"].join(" ")}>${amount_0}</button></div>;
      })}</div>;
    $[42] = setExactAmount;
    $[43] = valueAmount;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  const t22 = Math.floor(valueAmount / costPerPerson);
  let t23;
  if ($[45] !== t22) {
    t23 = <span className="font-bold text-[2.625rem] max-[440px]:text-base max-[640px]:text-2xl max-[800px]:text-[2rem]">{t22} people</span>;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== isFree || $[48] !== paymentRecurring) {
    t24 = !isFree && <span className="max-[440px]:block">  /  {paymentRecurring ? "month" : "one time"}</span>;
    $[47] = isFree;
    $[48] = paymentRecurring;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t23 || $[51] !== t24) {
    t25 = <p className="tracking-[0.02rem]">{t23}{t24}</p>;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== isFree || $[54] !== paymentRecurring || $[55] !== valueAmount) {
    t26 = <p className="tracking-[0.02rem] max-[440px]:text-right">{!isFree ? <><span className="font-bold text-[2rem] max-[440px]:text-base max-[640px]:text-[1.3rem] max-[800px]:text-[1.75rem]">${valueAmount}</span><span className="max-[440px]:block">  /  {paymentRecurring ? "month" : "one time"}</span></> : <span className="font-bold text-[2rem] max-[440px]:text-base max-[640px]:text-[1.3rem] max-[800px]:text-[1.75rem]">Free</span>}</p>;
    $[53] = isFree;
    $[54] = paymentRecurring;
    $[55] = valueAmount;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t25 || $[58] !== t26) {
    t27 = <div className="flex items-end justify-between gap-4">{t25}{t26}</div>;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t20 || $[61] !== t21 || $[62] !== t27) {
    t28 = <div className="border-b border-b-christ-gray-400 uppercase">{t7}{t20}{t21}{t27}</div>;
    $[60] = t20;
    $[61] = t21;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== isFree || $[65] !== paymentRecurring || $[66] !== valueAmount) {
    t29 = !isFree && !paymentRecurring && <ul className="mx-auto mt-16 grid max-w-[90%] grid-cols-3 gap-12 max-[640px]:max-w-[80%] max-[800px]:max-w-full max-[640px]:grid-cols-1 max-[800px]:grid-cols-2 max-[640px]:gap-6"><li className={`justify-self-center text-center ${valueAmount < 5 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">Stream in HD</span><span className="block text-[0.9rem] leading-[1.4]">Plus 1 month Spiritual Meal Planner</span></li><li className={`justify-self-center text-center ${valueAmount < 25 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">Plus deep dive guide</span></li><li className={`justify-self-center text-center ${valueAmount < 35 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">{"Plus bonus content, deleted scenes & extended interviews"}</span></li><li className={`justify-self-center text-center ${valueAmount < 100 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">{"Plus 'Thank You' film credit & Inner Circle Access"}</span></li><li className={`justify-self-center text-center ${valueAmount < 500 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">{"Plus 'Co-Producer' film credit & monthly live events"}</span></li></ul>;
    $[64] = isFree;
    $[65] = paymentRecurring;
    $[66] = valueAmount;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== isFree || $[69] !== paymentRecurring || $[70] !== valueAmount) {
    t30 = !isFree && paymentRecurring && <ul className="mx-auto mt-16 grid max-w-[90%] grid-cols-3 gap-12 max-[640px]:max-w-[80%] max-[800px]:max-w-full max-[640px]:grid-cols-1 max-[800px]:grid-cols-2 max-[640px]:gap-6"><li className={`justify-self-center text-center ${valueAmount < 5 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">Stream in HD</span><span className="block text-[0.9rem] leading-[1.4]">1 month Spiritual Meal Planner, deep dive guide</span></li><li className={`justify-self-center text-center ${valueAmount < 25 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">{"Plus monthly live Q&As, masterclasses, & more"}</span></li><li className={`justify-self-center text-center ${valueAmount < 35 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">{"Plus bonus content, deleted scenes & extended interviews"}</span></li><li className={`justify-self-center text-center ${valueAmount < 50 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">Plus exclusive chatroom with Co-creators</span></li><li className={`justify-self-center text-center ${valueAmount < 100 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">Plus 'Co-Producer' film credit</span></li><li className={`justify-self-center text-center ${valueAmount < 500 ? "opacity-50" : ""}`}><Icon name="check" className="mx-auto mb-3 size-8 max-w-8 max-[640px]:max-w-[1.8rem]" /><span className="block text-[0.9rem] leading-[1.4]">All previous perks</span><span className="block text-[0.9rem] leading-[1.4]">Plus 'Producer' film credit</span></li></ul>;
    $[68] = isFree;
    $[69] = paymentRecurring;
    $[70] = valueAmount;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== isFree) {
    t31 = isFree && <ul className="mt-16 grid justify-self-center text-center"><li className="justify-self-center"><span className="block uppercase">48 hour streaming pass</span></li></ul>;
    $[72] = isFree;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t28 || $[75] !== t29 || $[76] !== t30 || $[77] !== t31) {
    t32 = <div className="mb-12">{t28}{t29}{t30}{t31}</div>;
    $[74] = t28;
    $[75] = t29;
    $[76] = t30;
    $[77] = t31;
    $[78] = t32;
  } else {
    t32 = $[78];
  }
  return t32;
}